module.exports = __webpack_public_path__ + "graphql_playground.62eb7951.webm";